import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import dayjs from 'dayjs';

import API from '@sesame/web-api';

import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import { ILoadState, IWarranty } from 'src/types';
import { Spinner} from 'src/components/Spinner';

import { EditWarrantyDetails } from './EditWarrantyDetails';

export default function WarrantiesList() {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [displayState, setDisplayState] = useState<ILoadState>(ILoadState.NEW);
  const [warrantyList, setWarrantyList] = useState<IWarranty[]>([]);

  const getWarranties = async () => {
    if (isLoading) {
      return;
    }
    getAccessTokenSilently().then( accessToken => {
    API.get(accessToken,  '/api/v1/warranty')
      .then((response) => {
        setWarrantyList(response.data as IWarranty[]);
        setDisplayState(ILoadState.READY);
      })
      .catch((err) => {
        if (err.status === 404) {
          Alert(AlertTypes.ERROR, 'Not Found');
          setDisplayState(ILoadState.NOTFOUND);
          return;
        }
        setDisplayState(ILoadState.ERROR);
        Alert(AlertTypes.ERROR, err.message);
      });
    })
    setDisplayState(ILoadState.LOADING);
  }
  const onEditSave = () => {
    getWarranties();
  }

  React.useEffect(() => {
    getWarranties();
  }, [getAccessTokenSilently]);

  if (isLoading) {
    return <Spinner />
  }
  if (!isAuthenticated) {
    return <div><h1>Not Authorized</h1></div>
  }

  if (displayState === ILoadState.NEW || displayState === ILoadState.LOADING) {
    return <div><span data-uk-spinner className="uk-position-center" /></div>
  }

  return (
    <div className="uk-margin-small uk-margin-left uk-margin-right" >
      <h2> Warranties </h2>
      <div className="uk-align-right">
        <EditWarrantyDetails
          onSave={onEditSave} />
      </div>
      <div className="uk-align-left uk-grid" >
        <div className="uk-align-left">
          <table className="uk-table uk-table-divider uk-table-small uk-margin-right-small">
            <thead>
              <tr>
                <th>Warranty</th>
                <th>First Available</th>
                <th>Available Until</th>
                <th>Duration</th>
                <th>Service Hours</th>
                <th>Service Days</th>
                <th>Support Response Time</th>
                <th>Onsite Response Time</th>
              </tr>
            </thead>
            <tbody>
              {warrantyList.map(w => <tr key={w.warrantyId}>
                <td>{w.name}<br /><span className="uk-text-small">{w.description}</span></td>
                <td>{dayjs(w.firstAvailableDate).format('YYYY-MM-DD')}</td>
                <td>{dayjs(w.lastAvailableDate).format('YYYY-MM-DD')}</td>
                <td>{w.durationYears}</td>
                <td>{w.serviceHours}</td>
                <td>{w.serviceDays}</td>
                <td>{w.supportResponseTime}</td>
                <td>{w.onsiteResponseTime}</td>
                <td className="uk-text-right">
                  <EditWarrantyDetails
                    warrantyId={w.warrantyId}
                    onSave={onEditSave} />
                </td>
              </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
